const icons = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="512px"
		viewBox="-9 1 511 511.999"
		width="512px"
	>
		<g transform="matrix(1.19615 0 0 1.19615 -48.3503 10.6689)">
			<path
				d="m44.425781 32.351562c-6.382812 0-11.574219 5.191407-11.574219 11.570313v331.890625c0 6.378906 5.191407 11.570312 11.574219 11.570312h404.253907c6.378906 0 11.570312-5.191406 11.570312-11.570312 0-2.777344 0-324.945312 0-331.890625 0-6.378906-5.191406-11.570313-11.570312-11.570313-18.128907 0-387.746094 0-404.253907 0zm400.824219 36.664063h-352.402344v-21.660156h352.402344zm-397.398438-21.660156h29.996094v21.660156h-29.996094zm0 325.027343v-288.367187h397.398438v288.367187zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m160.527344 106.898438h-79.140625c-8.496094 0-15.410157 6.914062-15.410157 15.410156v92.742187c0 8.496094 6.914063 15.410157 15.410157 15.410157h79.144531c8.496094 0 15.410156-6.914063 15.410156-15.410157v-92.742187c-.003906-8.496094-6.914062-15.410156-15.414062-15.410156zm.410156 108.152343c0 .226563-.183594.410157-.410156.410157h-79.140625c-.226563 0-.410157-.1875-.410157-.410157v-92.742187c0-.226563.183594-.410156.410157-.410156h79.144531c.226562 0 .40625.1875.40625.410156zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m286.121094 106.898438h-79.140625c-8.5 0-15.414063 6.914062-15.414063 15.410156v92.742187c0 8.496094 6.914063 15.410157 15.414063 15.410157h79.140625c8.5 0 15.410156-6.914063 15.410156-15.410157v-92.742187c0-8.496094-6.910156-15.410156-15.410156-15.410156zm.410156 108.152343c0 .226563-.183594.410157-.410156.410157h-79.140625c-.226563 0-.410157-.1875-.410157-.410157v-92.742187c0-.226563.183594-.410156.410157-.410156h79.140625c.226562 0 .410156.1875.410156.410156zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m411.714844 106.898438h-79.144532c-8.496093 0-15.410156 6.914062-15.410156 15.410156v92.742187c0 8.496094 6.914063 15.410157 15.410156 15.410157h79.144532c8.5 0 15.410156-6.914063 15.410156-15.410157v-92.742187c0-8.496094-6.910156-15.410156-15.410156-15.410156zm.410156 108.152343c0 .226563-.183594.410157-.410156.410157h-79.144532c-.226562 0-.40625-.1875-.40625-.410157v-92.742187c0-.226563.183594-.410156.40625-.410156h79.144532c.226562 0 .410156.1875.410156.410156zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m168.4375 248.171875h-94.960938c-4.144531 0-7.503906 3.355469-7.503906 7.5s3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.355469 7.5-7.5s-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m168.4375 276.808594h-94.960938c-4.144531 0-7.503906 3.355468-7.503906 7.5 0 4.144531 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.355469 7.5-7.5 0-4.144532-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m168.4375 305.449219h-94.960938c-4.144531 0-7.503906 3.355469-7.503906 7.5 0 4.140625 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.359375 7.5-7.5 0-4.144531-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m168.4375 334.085938h-94.960938c-4.144531 0-7.503906 3.355468-7.503906 7.5 0 4.140624 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.359376 7.5-7.5 0-4.144532-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m294.03125 248.171875h-94.960938c-4.144531 0-7.503906 3.355469-7.503906 7.5s3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.355469 7.5-7.5s-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m294.03125 276.808594h-94.960938c-4.144531 0-7.503906 3.355468-7.503906 7.5 0 4.144531 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.355469 7.5-7.5 0-4.144532-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m294.03125 305.449219h-94.960938c-4.144531 0-7.503906 3.355469-7.503906 7.5 0 4.140625 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.359375 7.5-7.5 0-4.144531-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m294.03125 334.085938h-94.960938c-4.144531 0-7.503906 3.355468-7.503906 7.5 0 4.140624 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.359376 7.5-7.5 0-4.144532-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m419.625 248.171875h-94.960938c-4.144531 0-7.503906 3.355469-7.503906 7.5s3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.355469 7.5-7.5s-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m419.625 276.808594h-94.960938c-4.144531 0-7.503906 3.355468-7.503906 7.5 0 4.144531 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.355469 7.5-7.5 0-4.144532-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m419.625 305.449219h-94.960938c-4.144531 0-7.503906 3.355469-7.503906 7.5 0 4.140625 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.359375 7.5-7.5 0-4.144531-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m419.625 334.085938h-94.960938c-4.144531 0-7.503906 3.355468-7.503906 7.5 0 4.140624 3.359375 7.5 7.503906 7.5h94.960938c4.144531 0 7.5-3.359376 7.5-7.5 0-4.144532-3.355469-7.5-7.5-7.5zm0 0"
				fill="#F63D3D"
			/>
			<path
				d="m.5 375.8125c0 24.21875 19.703125 43.925781 43.925781 43.925781h178.300781v44.609375h-40.804687c-11 0-19.949219 8.949219-19.949219 19.945313v7.757812c0 11 8.949219 19.949219 19.949219 19.949219h47.128906c4.144531 0 7.5-3.359375 7.5-7.5 0-4.144531-3.355469-7.5-7.5-7.5h-47.128906c-2.730469 0-4.949219-2.222656-4.949219-4.949219v-7.757812c0-2.726563 2.21875-4.945313 4.949219-4.945313h129.257813c2.730468 0 4.949218 2.21875 4.949218 4.945313v7.757812c0 2.730469-2.21875 4.949219-4.949218 4.949219h-47.128907c-4.140625 0-7.5 3.355469-7.5 7.5 0 4.140625 3.359375 7.5 7.5 7.5h47.128907c11 0 19.949218-8.949219 19.949218-19.949219v-7.757812c0-10.996094-8.949218-19.945313-19.949218-19.945313h-40.804688v-44.609375h178.304688c24.21875 0 43.921874-19.707031 43.921874-43.925781v-138.675781c0-4.140625-3.355468-7.5-7.5-7.5-4.144531 0-7.5 3.359375-7.5 7.5v138.675781c0 15.949219-12.976562 28.921875-28.921874 28.921875-8.121094 0-402.925782 0-404.253907 0-15.949219 0-28.925781-12.972656-28.925781-28.921875v-331.890625c0-15.945313 12.976562-28.921875 28.925781-28.921875h404.253907c15.945312 0 28.921874 12.976562 28.921874 28.921875v158.214844c0 4.144531 3.355469 7.5 7.5 7.5 4.144532 0 7.5-3.355469 7.5-7.5v-158.214844c0-24.21875-19.703124-43.921875-43.921874-43.921875h-404.253907c-24.222656 0-43.925781 19.703125-43.925781 43.921875zm254.875 43.925781v44.609375h-17.648438v-44.609375zm0 0"
				fill="#F63D3D"
			/>
		</g>
	</svg>
);
export default icons;
